import {useState} from "react";
import React from "react";
import { Navbar } from "@allxsmith/bestax-bulma";
import {Link, useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import {getQuickLinksData} from "../../state/selectors";
import TransactionsNav from "./TransactionsNav";
import QuickLinksNav from "./QuickLinksNav";
import {useQuickLinkData} from "../../hooks/useQuickLinkData";
import InvoiceNav from "./InvoiceNav";
import {googleLogout} from "@react-oauth/google";

function Nav() {
  const location = useLocation();
  const [burgerActive, setBurgerActive] = useState(false);
  const quickLinksLoaded = useQuickLinkData({page_size: 50});
  const quickLinksData = useSelector(getQuickLinksData);
  if (!quickLinksLoaded) {
    return null;
  }

  const quickLinks = quickLinksData ? quickLinksData.results : [];

  const path = location.pathname.substring(1, location.pathname.length);
  // TODO(bestax-migrate): `hoverable` — move hoverable to the bestax Navbar.Dropdown container
  return (
    <Navbar fixed="top" className="hide-print">
      <Navbar.Brand>

        <Navbar.Burger
          className={burgerActive ? "navbar-burger is-active" : "navbar-burger"}
          onClick={() => setBurgerActive(!burgerActive)}
        />
      </Navbar.Brand>
      <Navbar.Menu
        className={burgerActive ? "navbar-menu is-active" : "navbar-menu"}
      >
        <Navbar.Start>
          <Navbar.Item
            className={path === "" ? "active-tab" : ""}
          >
            <Link
                to={"/"}
            >
              Home
            </Link>
          </Navbar.Item>
          <Navbar.Item
            className={path.includes("job") ? "active-tab" : ""}
          >
            <Link
              to={"/jobs"}
            >
              Jobs
            </Link>
          </Navbar.Item>
          <Navbar.Item
            className={path.includes("quote") ? "active-tab" : ""}
          >
            <Link to={"/quotes"}>
              Quotes
            </Link>
          </Navbar.Item>
          <Navbar.Item
            className={path === "inspections" ? "active-tab" : ""}
          >
            <Link to={"/inspections"}>
              Inspections
            </Link>
          </Navbar.Item>
          <Navbar.Dropdown
            className={path.indexOf("part") !== -1 ? "active-tab" : ""}
            color={"black"}
            hoverable
          >
            <Navbar.Link style={{color: "black"}}>Parts</Navbar.Link> {/*We use inline style as setting a classname of black with !important couldnt override the colour*/}
            <Navbar.DropdownMenu>
              <Navbar.Item
                className={path === "partorders" ? "active-tab" : ""}
              >
                <Link to={"/partorders"}>
                  Part Orders
                </Link>
              </Navbar.Item>
              <Navbar.Item
                className={path === "parthistory" ? "active-tab" : ""}
              >
                <Link to={"/parthistory"}>
                  Part History
                </Link>
              </Navbar.Item>
              <Navbar.Item
                className={path === "partLookup" ? "active-tab" : ""}
              >
                <Link to={"/partLookup"}>
                  Part Lookups
                </Link>
              </Navbar.Item>
              <Navbar.Item
                className={path === "parts" ? "active-tab" : ""}
              >
                <Link to={"/parts"}>
                  Part Expenses
                </Link>
              </Navbar.Item>
              <Navbar.Item
                className={path === "labelprinter" ? "active-tab" : ""}
              >
                <Link to={"/labelprinter"}>
                  Label Printer
                </Link>
              </Navbar.Item>
              <Navbar.Item>
                {/* Standalone tablet page (outside the React app) - job picker with book/typical times by reg */}
                <a href={"/job-menu.html"} target={"_blank"} rel={"noopener noreferrer"}>
                  Job Menu &amp; Book Times
                </a>
              </Navbar.Item>
            </Navbar.DropdownMenu>
          </Navbar.Dropdown>
          <Navbar.Item
            className={path === "workLookup" ? "active-tab" : ""}
          >
            <Link to={"/workLookup"}>
              Work Lookups
            </Link>
          </Navbar.Item>
          <Navbar.Dropdown
            className={(path === "invoicing" || path.includes("invoices"))  ? "active-tab" : ""}
            dropdown
            hoverable
          >
            <Navbar.Link style={{color: "black"}}>Invoicing</Navbar.Link>
            <InvoiceNav setMenuActive={setBurgerActive}/>
          </Navbar.Dropdown>
          <Navbar.Item
              className={(path === "rentals" || path.includes("rentals")) ? "active-tab" : ""}
          >
            <Link to={"/rentals"}>
              Rentals
            </Link>
          </Navbar.Item>
          <Navbar.Dropdown
            className={path.includes("vehicle") || path.includes('trackers') || path.includes("keys") ? "active-tab" : ""}
            hoverable
            dropdown
          >
            <Navbar.Link style={{color: "black"}}>Vehicles</Navbar.Link>
            <Navbar.DropdownMenu>
              <Navbar.Item>
                <Link to={"/vehicles"}>
                  Vehicles
                </Link>
              </Navbar.Item>
              <Navbar.Item>
                <Link to={"/keys"}>
                  Keys
                </Link>
              </Navbar.Item>
              <Navbar.Item>
                <Link to={"/trackers"}>
                  Vehicle Trackers
                </Link>
              </Navbar.Item>
            </Navbar.DropdownMenu>
          </Navbar.Dropdown>
          <Navbar.Item
            className={path.includes("movement") ? "active-tab" : ""}
          >
            <Link to={"/movements"}>
              Movements
            </Link>
          </Navbar.Item>
          <Navbar.Dropdown
            className={path.includes("contacts") ? "active-tab" : path.includes('accountbalance') ? 'active-tab' : ''}
            dropdown
            hoverable
          >
            <Navbar.Link style={{color: "black"}}>Contacts</Navbar.Link>
            <Navbar.DropdownMenu>
              <Navbar.Item
                  onClick={() => {
                    setBurgerActive(false);
                  }}
              >
                <Link to={"/contacts"}>
                  All Contacts
                </Link>
              </Navbar.Item>
              <Navbar.Item
                  onClick={() => {
                    setBurgerActive(false);
                  }}
              >
                <Link to={"/contacts?type=SP"}>
                  Suppliers
                </Link>
              </Navbar.Item>
              <Navbar.Item
                  onClick={() => {
                    setBurgerActive(false);
                  }}
              >
                <Link to={"/contacts?type=CC"}>
                  Customers
                </Link>
              </Navbar.Item>
              <Navbar.Item
                  onClick={() => {
                    setBurgerActive(false);
                  }}
              >
                <Link to={"/accountbalance"}>
                  Customer Account Balance
                </Link>
              </Navbar.Item>
            </Navbar.DropdownMenu>
          </Navbar.Dropdown>
          <Navbar.Dropdown
            className={path === "income" ? "active-tab" : ""}
            dropdown
            hoverable
          >
            <Navbar.Link style={{color: "black"}}>Income</Navbar.Link>
              <TransactionsNav transactionType='income' setMenuActive={setBurgerActive}/>
          </Navbar.Dropdown>
          <Navbar.Dropdown
            className={path === "expenses" || path === "po" ? "active-tab" : ""}
            dropdown
            hoverable
          >
            <Navbar.Link style={{color: "black"}}>Expenses</Navbar.Link>
              <TransactionsNav transactionType='expenses' setMenuActive={setBurgerActive}/>
          </Navbar.Dropdown>
          <Navbar.Item
            onClick={() => {
              setBurgerActive(false);
            }}
            className={path.includes("credit") ? "active-tab" : ""}
          >
            <Link to={"/credit"}>
              Credit Note
            </Link>
          </Navbar.Item>
          <Navbar.Item
            onClick={() => {
              setBurgerActive(false);
            }}
            className={path === "payments" ? "active-tab" : ""}
          >
            <Link to={"/payments"}>
              Payments
            </Link>
          </Navbar.Item>
          <Navbar.Item
            className={path === "diary" ? "active-tab" : ""}
            onClick={() => {
              setBurgerActive(false);
            }}
          >
            <Link to={"/diary"}>
              Diary
            </Link>
          </Navbar.Item>
          <Navbar.Item
            className={path === "reports" ? "active-tab" : ""}
            onClick={() => {
              setBurgerActive(false);
            }}
          >
            <Link to={"/reports"}>
              Reports
            </Link>
          </Navbar.Item>
          <Navbar.Dropdown
            className={path === "quicklinks" ? "active-tab" : ""}
            dropdown
            hoverable
          >
            <Navbar.Link style={{color: "black"}}>Quick Links</Navbar.Link>
            <QuickLinksNav quickLinks={quickLinks}/>
          </Navbar.Dropdown>
          <Navbar.Item
            className={path === "alllinks" ? "active-tab" : ""}
            onClick={() => {
              setBurgerActive(false);
            }}
          >
            <Link to={"/alllinks"}>
              Links
            </Link>
          </Navbar.Item>
          <Navbar.Item
            className={path === "settings" ? "active-tab" : ""}
            onClick={() => {
              setBurgerActive(false);
            }}
          >
            <Link to={"/settings"}>
              Settings
            </Link>
          </Navbar.Item>
        </Navbar.Start>
        <Navbar.Start position="end">
          <Navbar.Item
            onClick={() => {
              googleLogout();
              localStorage.clear();
              window.location.href = "/login";
            }}
            style={{color: "black"}}
          >
            Log out
          </Navbar.Item>
        </Navbar.Start>
      </Navbar.Menu>
    </Navbar>
  );
  // }
}

export default Nav;
